import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const GloryOfNation = () => {
  const homeMenu = [
    { label: "MUN", link: "/Mun" },
    { label: "Glory to the Nation", link: "/GloryOfNation" },
    {
      label: "Spic Macay Cultural and Heritage Club",
      link: "/SpocmacyColtoralHeritage",
    },
    {
      label: "Vocational Education Clubs (Middle Wing) ",
      link: "/vocationalClubmiddle",
    },
    {
      label: "Vocational Education Clubs (Senior Wing)",
      link: "/vocationalClub",
    },
    {
      label: "Vocational Education Clubs (Primary Wing)",
      link: "/VocationalClubPrimary",
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/blog-banner.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Glory Of Nation"
                breadEnd="Glory Of Nation"
                breadMid="Glory Of Nation"
              />
            </div>
          </div>
          <div class="text-box">
            <div class="blog-main-box mb-2">
              <div class="blogList row">
                <div class="blog-iframe col-md-3">
                  <iframe
                    src="https://www.youtube.com/embed/Pg9lciXvWe0"
                    title="Glory Of Nation"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <div class="blog-text col-md-9">
                  <p>
                    Lotus Valley International School, Gurugram celebrated 72nd
                    Constitution Day by organizing a national level inter-school
                    online event on 26th November 2021 ‘Lotus Discourse’21: We,
                    the People of India…’wherein 28 schools and 400 learners
                    across Delhi- NCR participated with full zeal and
                    enthusiasm. In order to monumentalize and pay tribute to our
                    Constitution makers, the event , aimed at highlighting and
                    reiterating the values and principles enshrined in the
                    Indian Constitution.It was a perfect platform for the Youth
                    of India to spread constitutional awareness across the
                    country. The focus of the discourse was to succinctly review
                    the working of the Indian Constitution. Through this event,
                    we brought forward the views of the young generation who not
                    only paid tribute to the national heroes who framed the
                    effective and just Constitution but also proposed the
                    modifications to help build a stronger and more resilient
                    India!
                  </p>
                </div>
              </div>
            </div>
            <div class="blog-main-box mb-2">
              <div class="blogList row">
                <div class="blog-iframe col-md-3">
                  <iframe
                    src="https://www.youtube.com/embed/fqLn2y_07Dk"
                    title="Glory Of Nation1"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <div class="blog-text col-md-9">
                  <p>
                    Lotus Discourse’21: We, the People of India…’was a
                    resounding success in promoting constitutional literacy and
                    engaging young learners in an interactive way to gain the
                    knowledge and skills needed for civic engagement in the 21st
                    century. Through the five unique and exemplary competitions,
                    Lotus Valley has set a new benchmark. <br />
                    The First Event,Tryst with a Twist
                    <br />
                    The second event was: Every Issue Counts <br />
                    The Third Event was: Colloquium <br />
                    The Fourth event was: Wings of Change <br />
                    The final event was: We the Youth: Arguably the Best
                    <br />
                    In all the events the learners through their distinctive
                    styles of discourse unanimously expressed the opinion that,
                    as the highest law of our country, the constitution is at
                    the centre of the political and social life of the country
                    and defines the relationship between the State and the
                    society, and between the different functions of the State.
                    Through this EVENT the young learners from various schools
                    made the substantial contribution in determining the
                    political future and to secure justice to all. e
                  </p>
                </div>
              </div>
            </div>
            <div class="blog-main-box mb-2">
              <div class="blogList row">
                <div class="blog-iframe col-md-3">
                  <iframe
                    src="https://www.youtube.com/embed/sT9OVCfKHFw"
                    title="Panel Discussion"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <div class="blog-text col-md-9">
                  <h4 className="color-red">Panel Discussion</h4>
                  <p>
                    On 26th January, 2022, Lotus Valley International School,
                    Gurugram, commemorated the 73rd Republic Day on the virtual
                    platform with great patriotic fervour, mirth and zest. The
                    zealous Lotusians demonstrated that even though the pandemic
                    has confined them to their homes, it cannot dampen their
                    patriotic spirit and pride for the nation. The highlight of
                    the event was the thought-provoking panel discussion on
                    Redefining Good Governance in India. This discussion aimed
                    to shed light on a subject that all of us, as responsible
                    citizens of our country, should reflect upon. The panelists
                    won the admiration of the audience with their eloquence and
                    awareness about the nation’s state of affairs. The
                    discussion was beautifully moderated by Parth Piyush Prasad,
                    President of the Student Council. The panelists deliberated
                    upon the key factors of good governance. They agreed that
                    features like accountability, transparency, citizen
                    participation, rule of law, efficiency and inclusiveness are
                    some of the most essential criteria for good governance.
                  </p>
                </div>
              </div>
            </div>
            <div class="blog-main-box mb-2">
              <div class="blogList row">
                <div class="blog-iframe col-md-3">
                  <iframe
                    src="https://www.youtube.com/embed/MuUS3Mtt0YI"
                    title="Glory to the Nation2"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <div class="blog-text col-md-9">
                  <h4 className="color-red">Glory to the Nation</h4>
                  <p>
                    Learners also presented an informative and impactful video
                    that took us on a journey through Indian history,
                    encapsulating many lifetimes into mere minutes. The audience
                    was enthralled and touched by the mellifluous and soulful
                    musical presentation ‘Long Live India’.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default GloryOfNation;
